module.exports = __webpack_public_path__ + "media/img/frontend_application/promo-icon-3fef4b52b2184c3d750fde7a4754b65a.png";